import React, { useRef, useState } from "react";
import { getColumnBody } from "../../../../../../../utils/HelperFuctions/supportHelper";
import { DataTable } from "primereact/datatable";
import { PaginatorTemplate } from "../../../../../../../ui/PaginatorTemplate/PaginatorTemplate";
import { Column } from "primereact/column";
import { classNames } from "primereact/utils";
import CustomLoading from "../../../../../../../ui/CustomSpinner/custom_spinner";

const Body = (props) => {
    const {
        selectedHeaders,
        selectedChargebacks,
        setSelectedChargebacks,
        selectedColumns,
        sortField,
        setSortField,
        sortOrder,
        setSortOrder,
        sortCount,
        setSortCount,
        pageSize,
        setPageSize,
        currentPage,
        setCurrentPage,
        pagination,
        loading,
        setPage,
        page,
    } = props;

    const ref = useRef(null);

    const [pageInputTooltip, setPageInputTooltip] = useState("Press 'Enter' key to go to this page.");

    const onSort = (e) => {
        if (e.sortField === sortField) {
            if (sortCount === 1) {
                setSortCount(0);
                setSortField(null);
                setSortOrder(null);
            } else {
                setSortCount(sortCount + 1);
                setSortField(e.sortField);
                setSortOrder(e.sortOrder);
            }
        } else {
            setSortField(e.sortField);
            setSortOrder(e.sortOrder);
        }
    };

    // Multiple Values Selection
    const handleSelectionChange = (event) => {
        // Handle checkbox selection functionality
        if (event.type === "checkbox") {
            setSelectedChargebacks(event.value);
        } else if (event.type === "all") {
            if (event.value.length > 0) {
                let _selectedChargebacks = selectedHeaders.filter((item) => !item.charge_back_settled);
                setSelectedChargebacks(_selectedChargebacks);
            } else {
                setSelectedChargebacks(event.value);
            }
        }
    };

    const renderSortIcon = (field) => {
        if (sortField === field) {
            return (
                <i
                    className={classNames("pi pi-fw", {
                        "pi-sort-alt": sortOrder === null,
                        "pi-sort-asc": sortOrder === 1,
                        "pi-sort-desc": sortOrder === -1,
                    })}
                />
            );
        }
        return null;
    };

    const columnComponents = selectedColumns.map((col) => {
        return (
            <Column
                key={col.field}
                field={col.field}
                header={col.header}
                body={getColumnBody(col.field)}
                sortable
                headerClassName={`${col.field === "invoice_amount" || col.field === "actual_cb" || col.field === "cb" || col.field === "adjusted_cb" ? "amount_column_alignment" : ""}`}
            >
                {renderSortIcon(col.field)}
            </Column>
        );
    });

    const onCustomPage = (event) => {
        setPageSize(event.rows);
        setCurrentPage(event.page + 1);
    };

    const getRowClassName = (rowData) => {
        if (rowData.charge_back_settled) {
            return "delete_row_color";
        } else if (rowData.is_terminated) {
            return "terminated_row_color";
        }
        return "";
    };

    return (
        <>
            <div className="col-12 p-0">
                {loading ? (
                    <CustomLoading />
                ) : (
                    <div className="card">
                        <DataTable
                            ref={ref}
                            value={selectedHeaders}
                            selection={selectedChargebacks.length === 0 ? null : selectedChargebacks}
                            onSelectionChange={handleSelectionChange}
                            onSort={onSort}
                            sortable
                            sortField={sortField}
                            sortOrder={sortOrder}
                            loading={loading}
                            onPage={onCustomPage}
                            paginatorTemplate={PaginatorTemplate(
                                pagination.isFirstPage,
                                pagination.isLastPage,
                                currentPage,
                                pagination.totalPages,
                                pageSize,
                                page,
                                pagination.totalRecords,
                                pageInputTooltip,
                                setCurrentPage,
                                setPage,
                                setPageSize,
                                setPageInputTooltip
                            )}
                            rows={pageSize}
                            paginator
                            responsiveLayout="scroll"
                            emptyMessage="No record available."
                            rowClassName={getRowClassName}
                        >
                            <Column selectionMode="multiple"></Column>
                            {columnComponents}
                        </DataTable>
                    </div>
                )}
            </div>
        </>
    );
};

export default Body;
